export default __webpack_public_path__ + "static/media/get_started_2.d6accaab.png";